<template>
  <container>
    <div class="subpage__cnt col-xl-10 offset-xl-1 text-center">

    </div>
    <div class="subpage-list uni-search-wrp">
      <div class="subpage-list-top">
        <img src="@/assets/img/building.png" alt="" class="city-dorms__icon">

        <div class="section__title-top">
          <div class="section__title">
            <span class="color-light-green">Search </span> Movie Collections!
          </div>
          <p class="section__title-txt">You can find movies from your favorite series, you can quickly reach movies according to your series genre flavour ! </p>
        </div>
      </div>
            <div class="desktop-drop">
                <div class="section__right">
                  <div class="section__select" v-if="universityDetails"> -->
                   </div>
                </div>
              </div> 
      <Hero :cities="genres" :studios="collectionList" :filter-dorm="false"/>
      <div class="result-bracket">
        <div class="result-bracket__title">
          <span class="result-bracket__count" v-if="list">{{ total_results }}</span> <span v-if="list">Collections Found!</span>
           <span v-if="!list">Series Loading!</span> 
        </div>

<!--                     <div class="desktop-drop">
                <div class="section__right">
                  <div class="section__select" v-if="universityDetails"> -->
                    <VueSelectTempFacultyNoFilter placeholder="Select Genre" :options="genres"
                                   @onselect="selectGenre"/>
<!--                   </div>
                </div>
              </div> -->
                    <!-- <v-select :options="genres" placeholder="Select Country" @onselect="selectFaculty"/> -->
      </div>

      <div class="flex-row" v-if="collections">
        <div class="subpage-list__item"
             v-for="collection in collections"
             :key="collection.id">
          <SerieCard :city="collection" />
        </div>

  <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
      </div>
      <!--<div class="featured-dorms__bottom text-center">-->
        <!--<v-link-->
          <!--to="/yurtlar"-->
          <!--class="button&#45;&#45;stroke round icon-transform"-->
          <!--title="See All"-->
          <!--icon="icon-arrow-long-right"-->
          <!--icon-position="right"-->
        <!--/>-->
      <!--</div>-->
    </div>
          <ContentLoader v-if="!collections && !mobileCheck"
          :height="700">
        <rect x="20" y="0" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="0" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="0" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="0" rx="3" ry="3" width="88" height="40" />

        <rect x="20" y="45" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="45" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="45" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="45" rx="3" ry="3" width="88" height="40" />

        <rect x="20" y="90" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="90" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="90" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="90" rx="3" ry="3" width="88" height="40" />

        <rect x="20" y="135" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="135" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="135" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="135" rx="3" ry="3" width="88" height="40" />        
      </ContentLoader>1

      <ContentLoader v-if="!collections && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />      
      </ContentLoader>
  <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
  <div slot="no-more"></div>
  <div slot="no-results"></div>
  </infinite-loading>
  </container>
  
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import FacultyCard from '@/components/UniSearchCard'
import Hero from '@/components/Home/CollectionSearch.vue'
import SerieCard from '@/components/SerieCard'
import { ContentLoader } from 'vue-content-loader'
import VueSelectTempFacultyNoFilter from '@/components/VueSelectTempFacultyNoFilter'
import axios from 'axios'
export default {
  name: 'SeriesSearch',
  components: {
    FacultyCard, Hero, SerieCard, ContentLoader, VueSelectTempFacultyNoFilter, InfiniteLoading
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Movie Collections',
       meta: [
         { vmid: 'description', name: 'description', content: 'You can find movies you search for, you can get news for the series you want, you can reach the movies in your favroite sires quickly!' },
         { vmid: 'keywords', name: 'keywords', content: 'hollywood movies, hollywod films, american movies, american cinema, holywoodskyline, movie search, yurt ara' }
       ],
       link: [
         { rel: 'canonical', href: window.location.origin + '/universiteler/' }
       ]      
    }
  },  
  data () {
    return {
      // list: null,
      page: 2,
      total_results: null,
  genres: [
    {
      id: 28,
      name: "All Genres",
      slug: 'action'
    },    
    {
      id: 28,
      name: "Action",
      slug: 'action'
    },
    {
      id: 12,
      name: "Adventure",
      slug: 'adventure'
    },
    {
      id: 16,
      name: "Animation",
      slug: 'animation'
    },
    {
      id: 35,
      name: "Comedy",
      slug: 'comedy'
    },
    {
      id: 80,
      name: "Crime",
      slug: 'crime'
    },
    {
      id: 99,
      name: "Documentary",
      slug: 'documentary'
    },
    {
      id: 18,
      name: "Drama",
      slug: 'drama'
    },
    {
      id: 10751,
      name: "Family",
      slug: 'family'
    },
    {
      id: 14,
      name: "Fantasy",
      slug: 'fantasy'
    },
    {
      id: 36,
      name: "History",
      slug: 'history'
    },
    {
      id: 27,
      name: "Horror",
      slug: 'horror'
    },
    {
      id: 10402,
      name: "Music",
      slug:'music'
    },
    {
      id: 9648,
      name: "Mystery",
      slug: 'mystery'
    },
    {
      id: 10749,
      name: "Romance",
      slug: 'romance'
    },
    {
      id: 878,
      name: "Science Fiction",
      slug: 'science-fiction'
    },
    {
      id: 10770,
      name: "TV Movie",
      slug: 'tv-movie'
    },
    {
      id: 53,
      name: "Thriller",
      slug: 'thriller'
    },
    {
      id: 10752,
      name: "War",
      slug: 'war'
    },
    {
      id: 37,
      name: "Western",
      slug: 'western'
    }
  ],
      collectionList: [
{
  genre: "Science Fiction",
  id: 10,
  name: "Star Wars Collection",
},
    {
      genre: "Animation",
      backdrop_path: "/2fNfuntrA7I4SGNTaGF0deLMiwW.jpg",
      id: 302331,
    },
{
  genre: "Horror",
  id: 656,
  name: "Saw Collection",
 },
{
  genre: "Animation",
  id: 386410,
  name: "Dragon Ball Collection",
},
{
  genre: "Animation",
  id: 34055,
  name: "Pokémon Collection",
},
{
  genre: "Fantasy",
  id: 1241,
  name: "Harry Potter Collection",
},
{
  genre: "Fantasy",
  id: 435259,
  name: "Fantastic Beasts Collection",
},
{
  genre: "Fantasy",
  id: 119,
  name: "The Lord of the Rings Collection",
 },
{
  genre: "Fantasy",
  id: 121938,
  name: "The Hobbit Collection",
},
{
  genre: "Action",
  id: 131635,
  name: "The Hunger Games Collection",
},
    {
      genre: "Superhero",
      id: 9744,
      name: "Fantastic Four Collection",
    },
{
  genre: "Superhero",
  id: 131296,
  name: "Thor Collection",
},
    {
      genre: "Action",
      id: 1575,
      name: "Rocky Collection",
    }
,    {
      genre: "Horror",
      id: 553717,
      name: "Creed Collection",
    },
    {
      genre: "Action",
      id: 5039,
    },
    {
      genre: "Action",
      id: 9485,
      name: "The Fast and the Furious Collection",
    },
    {
      genre: "Action",
      id: 131635,
      name: "The Hunger Games Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/rI8zOWkRQJdlAyQ6WJOSlYK6JxZ.jpg",
      id: 131292,
      name: "Iron Man Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/waZqriYTuBE3WqXI3SDGi3kfDQE.jpg",
      id: 556,
      name: "Spider-Man Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/zh72eVJTD5EssStCsNHqELuh6uD.jpg",
      id: 531241,
      name: "Spider-Man (Avengers) Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/14F6gMaRjzgsN6EEpiwH87R1I00.jpg",
      id: 573436,
      name: "Spider-Man: Spider-Verse Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/aLrNTcLN2kDu9jAJ4tS5haiWGc6.jpg",
      id: 125574,
      name: "The Amazing Spider-Man Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/rkVIb2JS3C2DBtjX8szbg37Qwff.jpg",
      id: 225941,
      name: "The Amazing Spider-Man TV Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/csERw2A3XIsGegkzil6UGpyhqfw.jpg",
      id: 209131,
      name: "Man of Steel Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/9DA9dxRE0fRlpl4amBmLCjQdZay.jpg",
      id: 286904,
      name: "Ultimate Avengers Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: null,
      id: 482721,
      name: "Alien Avengers Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/zuW6fOiusv4X9nnW3paHGfXcSll.jpg",
      id: 86311,
      name: "The Avengers Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/tp0buiNBb6iFjlr34lCB9ardTEA.jpg",
      id: 522577,
      name: "Avengers Grimm Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/zh72eVJTD5EssStCsNHqELuh6uD.jpg",
      id: 531241,
      name: "Spider-Man (Avengers) Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/c5ccDw4lcTUnYGdCxc2yEl8PjTk.jpg",
      id: 115762,
      name: "AVP Collection",
    },
    {
      genre: "Drama",
      backdrop_path: "/vhgPpFwb7Px6xAlIX09S1IhGXHl.jpg",
      id: 441439,
      name: "Alienation Trilogy",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/kB0Y3uGe9ohJa59Lk8UO9cUOxGM.jpg",
      id: 8091,
      name: "Alien Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/gWl5pN2FplE709aVtA4lakwsE6t.jpg",
      id: 115575,
      name: "Star Trek: Alternate Reality Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/9BQj9hq0aK6yM9Tm2NJ28jg572y.jpg",
      id: 151,
      name: "Star Trek: The Original Series Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/r7MMQenUURHhAVHFymtOb8AX4Bm.jpg",
      id: 115570,
      name: "Star Trek: The Next Generation Collection",
    },
    {
      genre: "Action",
      backdrop_path: "/jYl0UuJFcmhymv9ZNO14lPLDY1Z.jpg",
      id: 87359,
      name: "Mission: Impossible Collection",
    },
    {
      genre: "Action",
      backdrop_path: "/dOSECZImeyZldoq0ObieBE0lwie.jpg",
      id: 645,
      name: "James Bond Collection",
    },
    {
      genre: "Horror",
      backdrop_path: "/y3aWOInifbGKXM34KjtcMITrZRZ.jpg",
      id: 8864,
      name: "Final Destination Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/4UHZWw5lV3ZoadTjXuVOakdH32L.jpg",
      id: 120794,
      name: "Batman Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/xfKot7lqaiW4XpL5TtDlVBA9ei9.jpg",
      id: 263,
      name: "The Dark Knight Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/yCXuvuBUL2tFHXiSQkVSDWp1WIz.jpg",
      id: 248534,
      name: "Batman: The Dark Knight Returns Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: null,
      id: 696630,
      name: "The Lego Batman Collection",
      original_language: "en",
      original_name: "The Lego Batman Collection",
      overview: "A series of batman films based on the toys of the same name.",
      poster_path: null
    },
    {
      genre: "Superhero",
      backdrop_path: "/cp26uC7hCTXto8bAYYuKICQNBMl.jpg",
      id: 356688,
      name: "Batman Unlimited Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/36nlV0NWa4NUtLx89PzqtC9K9aG.jpg",
      id: 379475,
      name: "Batman Beyond Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/sVvEkTNx6SjwOb80iyURe5KHtcD.jpg",
      id: 334996,
      name: "Son of Batman Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/la0EhOrgVAiY8sf3ILz3wgoaNXH.jpg",
      id: 8537,
      name: "Superman Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/ufosHrm2Qh4AUpQPxIjxqBwY5pP.jpg",
      id: 290933,
      name: "Superman / Batman (Animated) Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: null,
      id: 404770,
      name: "Superman (DC Universe Animated) Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/xKL7q00o6kIME7h8XY9gu3CcaDt.jpg",
      id: 593251,
      name: "Superman (DC Animated Movie Universe) Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/csERw2A3XIsGegkzil6UGpyhqfw.jpg",
      id: 209131,
      name: "Man of Steel Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/zvZBNNDWd5LcsIBpDhJyCB2MDT7.jpg",
      id: 8650,
      name: "Transformers Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/AqPzj9uvp1aZt5zm0wAyJCFcGA9.jpg",
      id: 693368,
      name: "Scooby Doo Animated Collection",
    },
    {
      genre: "animation",
      backdrop_path: "/j2Ojh23iL4T5uNbEFwCikjXQXjF.jpg",
      id: 141290,
      name: "The Lord of the Rings Animated Collection",
    },    
    {
      genre: "Science Fiction",
      backdrop_path: "/fXVzk9OxQwROCuiWvd0Cv76qmZi.jpg",
      id: 399,
      name: "Predator Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/c5ccDw4lcTUnYGdCxc2yEl8PjTk.jpg",
      id: 115762,
      name: "AVP Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/azQScQWHpz5puIV4YeCcqgiT9Tn.jpg",
      id: 5547,
      name: "RoboCop Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/1ynqKxPc4sgDdweAItGt4QLDWkS.jpg",
      id: 91697,
      name: "Battlestar Galactica (Reboot) Collection",
    },
    {
      genre: false,
      backdrop_path: "/vI7quFooOFY81OjV5JrR8m7DvNU.jpg",
      id: 284151,
      name: "Battlestar Galactica (Original) Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/bSHZIvLoPBWyGLeiAudN1mXdvQX.jpg",
      id: 422837,
      name: "Blade Runner Collection",
    },
    {
      genre: "Fantasy",
      backdrop_path: "/ev9QybDDzVSahJQdOb71ZuqNVAo.jpg",
      id: 735,
      name: "Blade Collection",
    },
    {
      genre: "Action",
      backdrop_path: "/x4lV85mb7eDuibGS5Y5Hu1xqbdH.jpg",
      id: 102940,
      name: "Broken Blade Collection",
    },
	    {
      genre: "Adventure",
      backdrop_path: "/msP6KquobzwU0osaX22oWXEykR3.jpg",
      id: 201061,
      name: "War of the Worlds Collection",
    },
    {
      genre: "Fantasy",
      backdrop_path: "/jz7bMV4D6a0x81bfEZEVMXTqric.jpg",
      id: 565841,
      name: "The Immortal Wars Collection",
    },	
    {
      genre: "Horror",
      backdrop_path: "/5NTJZ571646mTziTOGt0jnq7uKe.jpg",
      id: 251937,
      name: "A Haunted House Collection",
    },
    {
      genre: "Adventure",
      backdrop_path: "/njFixYzIxX8jsn6KMSEtAzi4avi.jpg",
      id: 328,
      name: "Jurassic Park Collection",
	 },
     {
      genre: "Adventure",
      backdrop_path: "/zJd4E0ImT1U6O8k6aX3ssc9iUBS.jpg",
      id: 295,
      name: "Pirates of the Caribbean Collection",
    },
    {
      genre: "Action",
      backdrop_path: "/5kHVblr87FUScuab1PVSsK692IL.jpg",
      id: 1570,
      name: "Die Hard Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/gMWrKQjoTIpYjhc8SxZF20EDIES.jpg",
      id: 2150,
      name: "Shrek Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/9FBwqcd9IRruEDUrTdcaafOMKUq.jpg",
      id: 10194,
      name: "Toy Story Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/RhUxjzNojIJsdZSYTn0CQvdKsn.jpg",
      id: 2344,
      name: "The Matrix Collection",
    },
   {
      genre: "Animation",
      backdrop_path: "/yPyhZ5OpYs68Bb8u0PZ1tH0QIgd.jpg",
      id: 87118,
      name: "Cars Collection",
    },
    {
      genre: "Family",
      backdrop_path: "/6H6uS5f4SMBaN0xHNhmQqUOShAX.jpg",
      id: 85890,
      name: "The Librarian Collection",
    },
	{
      genre: "Action",
      backdrop_path: "/fSwYa5q2xRkBoOOjueLpkLf3N1m.jpg",
      id: 404609,
      name: "John Wick Collection",
    },
    {
      genre: "Superhero",
      backdrop_path: "/QtSxEuCwcZSfCTMZfER3nHDVsG.jpg",
      id: 453993,
      name: "The Wolverine Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/4VaLuyQvfXD4mH6Cu1L5apY9wLS.jpg",
      id: 306926,
      name: "Monsters Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/uzKkKhTWGSEdsN2rYanJTVAyTLi.jpg",
      id: 137696,
      name: "Monsters, Inc. Collection",
    },
    {
      genre: "Action",
      backdrop_path: "/uoDt3eCCKpcxSQVWjPTgN8T0gjm.jpg",
      id: 90863,
      name: "Rush Hour Collection",
    },
    {
      genre: "Action",
      backdrop_path: "/z2TbwtEzjMxYZ8TXfbJmhbahkom.jpg",
      id: 304,
      name: "Ocean's Collection",
    },
    {
      genre: "Action",
      backdrop_path: null,
      id: 701183,
      name: "Ocean's Eight Collection",
    },
    {
      genre: "Horror",
      backdrop_path: "/oU1hA6PorJHcvsmhIdQOcxze6QC.jpg",
      id: 313086,
      name: "The Conjuring Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/cpmbkwSxZnKO69V82A9a34tvk2E.jpg",
      id: 528,
      name: "The Terminator Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/lzTIAbvMeGWB7PUrmBZXulGA28M.jpg",
      id: 14740,
      name: "Madagascar Collection",
    },
    {
      genre: "Action",
      backdrop_path: "/vA5xMglyZv7yzDTj1qUTU4OvelV.jpg",
      id: 31562,
      name: "The Bourne Collection",
    },	
    {
      genre: "Animation",
      backdrop_path: "/2hC8HHRUvwRljYKIcQDMyMbLlxz.jpg",
      id: 137697,
      name: "Finding Nemo Collection",
    },   
    {
      genre: "Adventure",
      backdrop_path: "/9f8kjuytZPJEPf1bhJgkekaoanr.jpg",
      id: 84,
      name: "Indiana Jones Collection",
    },
    {
      genre: "Adventure",
      backdrop_path: "/3ZzA3b8K6ajpe4ZcLgqucDyNkoQ.jpg",
      id: 222049,
      name: "The Adventures of Young Indiana Jones Collection",
    },
    {
      genre: "Action",
      backdrop_path: "/xKz6YaOvmnIJQ3MYIpnaa7FBaAB.jpg",
      id: 86055,
      name: "Men In Black Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/1Jj7Frjjbewb6Q6dl6YXhL3kuvL.jpg",
      id: 529892,
      name: "Black Panther Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/c9C9Pg2QctyjZHRmS0P8rZg1OTA.jpg",
      id: 264,
      name: "Back to the Future Collection",
    },
    {
      genre: "Drama",
      backdrop_path: "/3WZTxpgscsmoUk81TuECXdFOD0R.jpg",
      id: 230,
      name: "The Godfather Collection",
    },
    {
      genre: "Horror",
      backdrop_path: "/kriNR9A8Lhk2tFzbVQkhepXymEr.jpg",
      id: 33514,
      name: "The Twilight Collection",
    },
    {
      genre: "Horror",
      backdrop_path: "/oboBn4VYB79uDxnyIri0Nt3U3N2.jpg",
      id: 535313,
      name: "Godzilla Collection",
    },
    {
      genre: "Fantasy",
      backdrop_path: "/vlv2skpXYg02TRg1iyXGvDvZSZ9.jpg",
      id: 420,
      name: "The Chronicles of Narnia Collection",
    },
    {
      genre: "Adventure",
      backdrop_path: "/2NQmgzxyzftJ1ZoUqPyO5TRGvfU.jpg",
      id: 2326,
      name: "Underworld Collection",
    },
    {
      genre: "Adventure",
      backdrop_path: "/1BeKi6IytbfQlQocJSvP2k6sO1a.jpg",
      id: 1733,
      name: "The Mummy Collection",
    },
    {
      genre: "Adventure",
      backdrop_path: "/aJQsaYuDvawCyXgjq8JepPI4tz.jpg",
      id: 2467,
      name: "Tomb Raider Collection",
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/8utTJ9WoQeYcZ0Ztciv6auqwLXl.jpg",
      id: 17255,
      name: "Resident Evil Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/TSpFZFIgVX4I3Zsnlm3HAlDO14.jpg",
      id: 133352,
      name: "Resident Evil: Biohazard Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/2Mb92Ssoe1eUecvrCe2pEvgAlmv.jpg",
      id: 8354,
      name: "Ice Age Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/8wvxr06XNW2zofbOHQqEgokTmLx.jpg",
      id: 315595,
      name: "Tinker Bell Collection",
    },
    {
      genre: "Adventure",
      backdrop_path: "/a0GLVfaDSf5GNZKK5H4FgGCD2VW.jpg",
      id: 52984,
      name: "National Treasure Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/uDosHOFFWtF5YteBRygHALFqLw2.jpg",
      id: 77816,
      name: "Kung Fu Panda Collection",

    },    
    {
      genre: "Animation",
      backdrop_path: "/qI483yHct3PBtIiOH3K3SVNUDq5.jpg",
      id: 167613,
      name: "Alvin and the Chipmunks Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/syWm5FMScW6JHaCM2C9aduCzUtp.jpg",
      id: 86029,
      name: "Charlie's Angels Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/iVqkNuy2jpcurdk2ZH2iAexJTo6.jpg",
      id: 437451,
      name: "Cinderella Story Collection",
    }, 
    {
      genre: "Comedy", //"comedy, Drama,Family"
      backdrop_path: "/t1mwGPJi3NkwMeyeUHr9zlQhlTo.jpg",
      id: 87253,
      name: "High School Musical Collection",
    },
    {
      genre: "Adventure",
      backdrop_path: "/wZCWCe4jPJz04dvVGLQ8TtOq9Js.jpg",
      id: 1657,
      name: "Zorro Collection",
    },
    {
      genre: "Comedy",
      backdrop_path: "/z0nqqHwEY3niKa41kKbR4zhnvHw.jpg",
      id: 85943,
      name: "Night at the Museum Collection",
    },   
    {
      genre: "Animation",
      backdrop_path: "/uzQqTJMTCcAbXCg3LUsiA8cJ5m0.jpg",
      id: 87236,
      name: "Mulan Collection",
    },
    {
      genre: "Animation",
      backdrop_path: "/naeLgo2bt4WKfHF4BTrG6mkmjiY.jpg",
      id: 86027,
      name: "Aladdin Collection",
    },
    {
      genre: "Animation",
      backdrop_path: '/qNNOYLWLlEQARRT0z37DSrWx3NV.jpg',
      id: 33085,
      name: 'The Little Mermaid Collection',
    },
    {
      genre: "Animation",
      backdrop_path: '/hw43q6AkuoRDFvuSWsxDG0A5AK6.jpg',
      id: 422361,
      name: 'Barbie A Mermaid Tale Collection',
    }, 
    {
      genre: "Animation",
      backdrop_path: '/fw6YfVOmK0tVtaSUGb3GvLzEmvK.jpg',
      id: 141084,
      name: "Happily N'Ever After Collection",
    },
    {
      genre: "Horror",
      backdrop_path: null,
      id: 535121,
      name: "Halloween Nightmare Collection",
    },
    {
      genre: "Western",
      backdrop_path: null,
      id: 492980,
      name: "Bonanza Movie Collection",
    },
    {
      adult: "College",
      backdrop_path: "/pkRyV44Zyn6KOySQQT9DHbAhT8D.jpg",
      id: 201778,
      name: "Dorm Daze Collection",
    },
    {
      adult: "College",
      backdrop_path: "/afX0zjd1fFYNXrndzD9jd7gHvi3.jpg",
      id: 43220,
      name: "National Lampoon's Van Wilder Collection",
    },
    {
      adult: "Animation",
      backdrop_path: "/lB4l8H0jgPp2bf4NV2aZPIyytdQ.jpg",
      id: 427084,
      name: "The Secret Life of Pets Collection",
    },
    {
      adult: "Superhero",
      backdrop_path: "/xKL7q00o6kIME7h8XY9gu3CcaDt.jpg",
      id: 593251,
      name: "The Death of Superman Collection",
    },
    {
      genre: "Action",
      backdrop_path: null,
      id: 606601,
      name: "Commando Collection",
    },
    {
      genre: "Action",
      backdrop_path: null,
      id: 537303,
      name: "Strike Commando Collection",
    },
    {
      genre: "Horror",
      backdrop_path: "/thmNPh9FbKrkVcKhDmVWhw92s86.jpg",
      id: 133923,
    },
    {
      genre: "Horror",
      backdrop_path: "/bR2zZkiT0mdwfrQl7CQPvqB8nEu.jpg",
      id: 297501,
      name: "I'm A Zombie Collection",
    },
    {
      genre: "Horror",
      backdrop_path: "/n6XNnXTMZVTttt338CrBkfKPuOd.jpg",
      id: 537982,
      name: "Zombieland Collection",
    },
    {
      genre: "Horror",
      backdrop_path: null,
      id: 268103,
      name: "Zombie Planet Trilogy",
    },
    {
      genre: "Horror",
      backdrop_path: null,
      id: 124930,
    },
    {
      genre: "Horror",
      backdrop_path: "/tXXPOkcFLcDiJ4OU5SOU3JnhQrg.jpg",
      id: 126209,
      name: "Halloween (Rob Zombie Series) Collection",
    },
    {
      genre: "Horror",
      backdrop_path: null,
      id: 683698,
      name: "Z-O-M-B-I-E-S Collection",
    },
    {
      genre: "Horror",
      backdrop_path: "/7q6Os1kMEFttOkvpuzZsrwCyVRe.jpg",
      id: 117965,
      name: "The Zombie Diaries Collection",
    },
    {
      genre: "Horror",
      backdrop_path: "/tTNiHIi4nvvBWVLx51k6r99aBwo.jpg",
      id: 363386,
      name: "Rape Zombie: Lust of the Dead Collection",
    },
    {
      genre: "Horror",
      backdrop_path: "/nV090IHp1kG5oMgDCmGSYAwkN8D.jpg",
      id: 286038,
      name: "Dead Snow Collection",
    },
    {
      genre: "Horror",
      backdrop_path: null,
      id: 568449,
      name: "Zombie Massacre Collection",
    },
    {
      genre: "Horror",
      backdrop_path: null,
      id: 133922,
    },
    {
      genre: "Horror",
      backdrop_path: null,
      id: 447312,
    },
    {
      genre: "Horror",
      backdrop_path: "/osLewbX6FJMy1iUcNHm6hoiNH0j.jpg",
      id: 105625,
      name: "House of 1000 Corpses Collection",
    }            
      ],
      collections: null
    }
  },
  methods: {
    infiniteHandler ($state) {
      let self = this
      axios.get(`/3/search/collection?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&query=collection&page=${this.page}`)
        .then(response => {
          this.page += 1
          // self.pagination = response.data.data
            //if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) !== true && Object.keys(response.data.data.data).length !== 0) {
            if (response.data.results.length !== 0 ) {              
              response.data.results.forEach(item => {
                self.collections.push(item)
              })
              $state.loaded()
            } else {
              $state.complete()
            }          
          // self.dorms = response.data.data.data
       //   self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })      
    },    
    selectGenre(opt) {/*
      this.list.filter(item => {
          if(item.code) {
          return item.origin_country== opt.code
          } else return ''
        })
*/
if(opt.name == 'All Genres') {
  this.movies = this.list
}
else {
this.movies = this.list.filter(function (el) {
  return el.genre == opt.name
})
}
// this.movies = newArray
    },
    toggle (index) {
      // this.accordions.forEach((item) => {
      //   item.active = false
      // })
      this.accordions[index].active = !this.accordions[index].active
    },
    getMovies () {
      let self = this
      axios.get('/3/search/collection?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&query=collection&page=1')
        .then(response => {
          self.collections = response.data.results
          self.total_results = response.data.total_results
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    // this.movies = this.list
    this.getMovies()
  },
  computed: {
    mobileCheck() {
     var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check
  },
    getFiltered (options) {
        return this.countries.filter(item => {
          if(item.name) {
          return item.name.toLocaleUpperCase().indexOf(this.search.toLocaleUpperCase()) !== -1
          } else return ''
        })
    },        
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/uni-search";
</style>
